import { useMemo } from 'react'

interface MemberLimitsData {
  maxAllowedMembers: number | null
  currentMemberCount: number
}

interface UseMemberLimitsReturn {
  maxAllowedMembers: number | null
  currentMemberCount: number
  isAtMemberLimit: boolean
}

export const useMemberLimits = ({
  maxAllowedMembers,
  currentMemberCount,
}: MemberLimitsData): UseMemberLimitsReturn => {
  const isAtMemberLimit = useMemo(
    () =>
      maxAllowedMembers !== null &&
      maxAllowedMembers > 0 &&
      currentMemberCount >= maxAllowedMembers,
    [maxAllowedMembers, currentMemberCount]
  )

  return { maxAllowedMembers, currentMemberCount, isAtMemberLimit }
}
